import { useEffect, useState } from "react";
import { api } from "../lib/api";

export const ProofImage = ({ path, className = "", testId }) => {
  const [url, setUrl] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let objectUrl;
    let cancelled = false;
    api.get(`/files/${path}`, { responseType: "blob" })
      .then(({ data }) => {
        if (cancelled) return;
        objectUrl = URL.createObjectURL(data);
        setUrl(objectUrl);
      })
      .catch(() => setFailed(true));
    return () => { cancelled = true; if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [path]);

  if (failed) return null;
  return (
    <div className={className} data-testid={testId}>
      {url ? (
        <img src={url} alt="proof" className="max-h-72 w-full rounded-xl border border-border object-cover" />
      ) : (
        <div className="h-40 w-full animate-pulse rounded-xl bg-muted" />
      )}
    </div>
  );
};
